import styled from "styled-components";
import { MessageFile } from "common/message/dto/MessageFile";
import DeleteIcon from "@mui/icons-material/Delete";
import {
  MESSAGE_FILE_DELETE_CONFIRM_TEXT,
  MESSAGE_FILE_DELETE_CONFIRM_TITLE,
} from "../../../MessageSingleNav/MessageSingleNav.const";
import useConfirm from "common/modal/ConfirmDialog";
import { fileNameGet } from "common/util/file/file_common";

type MessageFileItemProps = {
  messageFile: MessageFile;
  deleteHandle: Function;
  ind: number;
};

const MessageFileItem = ({
  messageFile,
  deleteHandle,
  ind,
}: MessageFileItemProps) => {
  const actionConfirm = useConfirm();

  const deleteClickHandle = async () => {
    let check = false;
    try {
      check = await actionConfirm({
        title: MESSAGE_FILE_DELETE_CONFIRM_TITLE,
        message: MESSAGE_FILE_DELETE_CONFIRM_TEXT,
      });
    } catch (err) {
      console.log("confirm err");
    }
    if (check) {
      deleteHandle(ind);
    }
  };

  return (
    <Div>
      <div>{fileNameGet(messageFile.path)}</div>
      <DivDelete>
        <DeleteIconNav onClick={deleteClickHandle} />
      </DivDelete>
    </Div>
  );
};

const DeleteIconNav = styled(DeleteIcon)`
  cursor: pointer;
`;

const Div = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
`;

const DivDelete = styled.div`
  margin-left: 1rem;
`;

export default MessageFileItem;
